module.exports = __webpack_public_path__ + "img/inspiration.000ed785.png";